import { render, staticRenderFns } from "./ReviewSitecore.vue?vue&type=template&id=1e767675"
import script from "./ReviewSitecore.vue?vue&type=script&lang=js"
export * from "./ReviewSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports